// Human-friendly fulfillment stage labels for acrylic / plaque orders.
// DB status keys are unchanged — this is display-only mapping.
export const PLAQUE_STATUS_LABELS = {
  pending_payment: 'Awaiting Payment',
  pending_admin_fulfillment: 'Order Received',
  processing: 'In Review',
  ordered_with_supplier: 'In Production',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

export const plaqueStatusLabel = (s) =>
  PLAQUE_STATUS_LABELS[s] || (s || '').replace(/_/g, ' ');

// Family-facing stage labels + "what happens next" copy, mirrored from
// backend notifications.PLAQUE_CUSTOMER_STATUS.
export const PLAQUE_CUSTOMER_STATUS = {
  pending_admin_fulfillment: {
    label: 'Order Received',
    next: 'Our team is reviewing your order details and QR artwork before production begins.',
  },
  processing: {
    label: 'In Review',
    next: "We're preparing your plaque for production. We'll email you when it moves to the workshop.",
  },
  ordered_with_supplier: {
    label: 'In Production',
    next: "Your plaque is being crafted. We'll send your tracking number the moment it ships.",
  },
  shipped: {
    label: 'Shipped',
    next: 'Your plaque is on its way — follow it with the tracking details below.',
  },
  delivered: {
    label: 'Delivered',
    next: 'Your plaque has been delivered. We hope it brings comfort.',
  },
  cancelled: {
    label: 'Cancelled',
    next: 'This order was cancelled. If a payment was made, your refund will follow shortly.',
  },
  refunded: {
    label: 'Refunded',
    next: 'Your payment for this order has been refunded.',
  },
};

export const PLAQUE_TIMELINE = [
  'pending_admin_fulfillment', 'processing', 'ordered_with_supplier', 'shipped', 'delivered',
];

export const plaqueCustomerStatus = (s) =>
  PLAQUE_CUSTOMER_STATUS[s] || { label: plaqueStatusLabel(s), next: '' };
